/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {  Module } from '@msdyn365-commerce-modules/utilities';
import { Carousel } from '@msdyn365-commerce/components';
import classnames from 'classnames';
import * as React from 'react';
import { ICarouselViewProps } from './carousel';

const CarouselView: React.FC<ICarouselViewProps> = props => (
        <Module {...props.carouselContainer} {...props.renderModuleAttributes(props)}>
            <Carousel
                className={classnames(props.closeAnimation)}
                activeIndex={props.activeIndex}
                next={props.next}
                previous={props.previous}
                pause={props.config.pauseOnHover ? 'hover' : false}
                ride={props.config.autoplay ? 'carousel' : undefined}
                autoplay={props.config.autoplay}
                interval={props.config.interval}
                transitionType={(props.config.transitionType) ? props.config.transitionType : undefined}
                items={props.slots && props.slots.content && props.slots.content.length ? props.slots.content : []}
                hideFlipper={props.config.hideFlipper}
                dismissEnabled={props.config.dismissEnabled}
                onIndicatorsClickHandler={props.onIndicatorsClickHandler}
                handleDismissCarousel={props.handleDismissCarousel}
                dismissCarouselAriaText={props.resources && props.resources.ariaLabelForDismissButton}
                indicatorAriaText={props.resources && props.resources.ariaLabelForSlide}
                directionTextPrev={props.resources && props.resources.flipperPrevious}
                directionTextNext={props.resources && props.resources.flipperNext}
                handleOnExited={props.handleOnExited}
                handleOnExiting={props.handleOnExiting}
                telemetryContent={props.telemetryContent}
            />
        </Module>
);

export default CarouselView;
